module.exports = __webpack_public_path__ + "static/media/vi.3c9acbec.svg";